<template>
  <list-page-shell>
    <div class="overview-grid">
      <div class="overview-card">
        <span>{{ $t('systemOverviewPage.users') }}</span>
        <strong>{{ overview.userCount || 0 }}</strong>
      </div>
      <div class="overview-card">
        <span>{{ $t('systemOverviewPage.roles') }}</span>
        <strong>{{ overview.roleCount || 0 }}</strong>
      </div>
      <div class="overview-card">
        <span>{{ $t('systemOverviewPage.menus') }}</span>
        <strong>{{ overview.menuCount || 0 }}</strong>
      </div>
      <div class="overview-card">
        <span>{{ $t('systemOverviewPage.oauth') }}</span>
        <strong>{{ overview.oauthConfigured ? $t('systemOverviewPage.ready') : $t('systemOverviewPage.missing') }}</strong>
      </div>
    </div>
  </list-page-shell>
</template>

<script>
import ListPageShell from '@/components/ListPageShell.vue'
import { getSystemOverview } from '@/api/system'

export default {
  name: 'SystemOverview',
  components: { ListPageShell },
  data() {
    return { overview: {} }
  },
  async created() {
    const resp = await getSystemOverview()
    this.overview = resp.data || resp
  }
}
</script>

<style scoped>
.overview-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.overview-card {
  padding: 18px;
  border-radius: 12px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  box-shadow: var(--shadow-card);
}

.overview-card span {
  display: block;
  color: var(--color-text-sub);
  margin-bottom: 8px;
}

.overview-card strong {
  color: var(--color-text);
  font-size: 24px;
}
</style>
